module.exports = "<div *ngIf=\"!loading\" [innerHTML]=\"data\">\n\n</div>\n<novo-loading *ngIf=\"loading\"></novo-loading>\n"